import { connectRouter } from "connected-react-router";
import { combineReducers } from "redux";

import { agentGroups } from "./AgentGroupsReducer";
import { apiSpecs } from "./ApiSpecsReducer";
import { elements } from "./ElementsReducer";
import { environmentVariables } from "./EnvironmentVariablesReducer";
import { processReducer as process } from "./ProcessReducer";
import { subProcesses } from "./SubProcessReducer";
import { tasks } from "./TasksReducer";
import { testProcess } from "./TestProcessReducer";
import { timeZones } from "./TimeZoneReducer";
import { uiState } from "./UIStateReducer";
import { validation } from "./ValidationReducer";
import { snippets } from "./SnippetsReducer";
import { processVariables } from "./ProcessVariablesReducer";


export default (history: any) => combineReducers({
    router: connectRouter(history),
    process,
    agentGroups,
    apiSpecs,
    elements,
    environmentVariables,
    subProcesses,
    tasks,
    testProcess,
    timeZones,
    uiState,
    validation,
    snippets,
    processVariables
});
